module.exports = __webpack_public_path__ + "static/media/Rajesh-Shenoy (1).5f80ecad.jpg";